module.exports = __webpack_public_path__ + "static/img/006.8bf661e7.svg";